import * as types from './actionTypes';

export const getReferralsList = (payload) => ({
  type: types.GET_REFERRALS_LIST,
  payload,
});

export const setReferralsList = (payload) => ({
  type: types.SET_REFERRALS_LIST,
  payload,
});

export const setReferralsListFailed = () => ({
  type: types.SET_REFERRALS_LIST_FAILED,
});

export const addReferral = (payload) => ({
  type: types.ADD_REFERRAL,
  payload,
});

export const addReferralSuccess = () => ({
  type: types.ADD_REFERRAL_SUCCESS,
});

export const addReferralFailed = () => ({
  type: types.ADD_REFERRAL_FAILED,
});

export const clearAddReferralSuccess = () => ({
  type: types.CLEAR_ADD_REFERRAL_SUCCESS,
});

export const getReferralDetails = (payload) => ({
  type: types.GET_REFERRAL_DETAILS,
  payload:
    typeof payload === 'object' && payload !== null && !Array.isArray(payload)
      ? payload
      : { id: payload },
});

export const setReferralDetails = (payload) => ({
  type: types.SET_REFERRAL_DETAILS,
  payload,
});

export const setReferralDetailsFailed = () => ({
  type: types.SET_REFERRAL_DETAILS_FAILED,
});

export const clearReferralDetails = () => ({
  type: types.CLEAR_REFERRAL_DETAILS,
});

export const updateReferralStatus = (payload) => ({
  type: types.UPDATE_REFERRAL_STATUS,
  payload,
});

export const updateReferralStatusSuccess = () => ({
  type: types.UPDATE_REFERRAL_STATUS_SUCCESS,
});

export const updateReferralStatusFailed = () => ({
  type: types.UPDATE_REFERRAL_STATUS_FAILED,
});

export const clearReferralStatusUpdateSuccess = () => ({
  type: types.CLEAR_REFERRAL_STATUS_UPDATE_SUCCESS,
});
